import { render, staticRenderFns } from "./SocialNetworksFooter.vue?vue&type=template&id=dbdf8fa6"
import script from "./SocialNetworksFooter.vue?vue&type=script&lang=js"
export * from "./SocialNetworksFooter.vue?vue&type=script&lang=js"
import style0 from "./SocialNetworksFooter.vue?vue&type=style&index=0&id=dbdf8fa6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports